import { render, staticRenderFns } from "./ConfigurarNotificacion.vue?vue&type=template&id=35b2a384&scoped=true&"
import script from "./ConfigurarNotificacion.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarNotificacion.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarNotificacion.vue?vue&type=style&index=0&id=35b2a384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2a384",
  null
  
)

export default component.exports